import Overlay from "../../../Componentes/Overlay";
import SidebarMenu from "../../../Componentes/SideMenu";
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import { useModal } from "../../../contexts/ModalContext";

const SidebarPedidos = ({
    podeNovoPedidoCompra,
    podeCriarGrupo,
    podeGerenciarGrupos,
    podeEmailsBoletim,
}) => {

    const { closeModal, openModal } = useModal();

    const handleOpenNovoPedidoCompra = () => {

        closeModal();
        openModal("modalNovoPedidoCompra");

    }

    const handleOpenNovoGrupo = () => {

        closeModal();
        openModal("modalNovoGrupo");

    }

    const handleOpenGerenciarGrupos = () => {

        closeModal();
        openModal("modalGerenciarGrupos");

    }

    const handleOpenEmailsBoletim = () => {

        closeModal();
        openModal("modalEmailsBoletim");

    }

    return (
        <>
            <Overlay state={ true } changeContent={ closeModal } >
                <SidebarMenu>
                    {
                        podeNovoPedidoCompra && (
                            <SideMenuBtn
                                button="NOVO PEDIDO DE COMPRA"
                                clickFunc={ handleOpenNovoPedidoCompra }
                            />
                        )
                    }
                    {
                        podeCriarGrupo && (
                            <SideMenuBtn
                                button="CRIAR GRUPO"
                                clickFunc={ handleOpenNovoGrupo }
                            />
                        )
                    }
                    {
                        podeGerenciarGrupos && (
                            <SideMenuBtn
                                button="GERENCIAR GRUPOS"
                                clickFunc={ handleOpenGerenciarGrupos }
                            />
                        )
                    }
                    {
                        podeEmailsBoletim && (
                            <SideMenuBtn
                                button="E-MAILS BOLETIM"
                                clickFunc={ handleOpenEmailsBoletim }
                            />
                        )
                    }
                </SidebarMenu>
            </Overlay>
        </>
    )
}

export default SidebarPedidos;